<template>
    <div class="form-group">
        <div class="form-check">
            <input 
                @input="handleInput"
                type="checkbox"
                :name="name"
                :id="getId"
                :required="required"
                :disabled="disabled"
                :value="value"
                :checked="value"
                class="form-check-input"
                v-bind:class="{ 'is-invalid': error }"
            >

            <label class="form-check-label" :for="getId">
                {{ label }}
                {{ required ? '*' : '' }}
            </label>

            <small
                v-if="helperText"
                class="form-text"
                v-bind:class="{ 'invalid-feedback': error, 'text-muted': !error }"
            >
                {{ helperText }}
            </small>
        </div>
    </div>
</template>

<script>


export default {
    components: {  },
    props: {
        id: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        value: {
            type: Boolean,
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        helperText: {
            type: String,
            required: false,
            default: null
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data(){
        return {
            content: this.value,
            randomId: null,
        };
    },
    computed: {
        getId () {
            return this.id ? this.id : this.randomId
        }
    },
    methods: {
        handleInput (e) {
            this.$emit('input', e.target.checked)
            this.$emit('change', e.target.checked)
        }
    },
    mounted() {
        this.randomId = Math.random().toString(36).substr(2, 9)
    }
}
</script>

<style scoped lang="scss">
</style>
